import { fg } from '@atlaskit/platform-feature-flags';
import type {
	AiFeatureRequestEnvelopeRovoButtonNudgeRecommendationRequest,
	RovoButtonNudgeRecommendationResponse,
} from '@atlassian/convo-ai-api';

// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { isBrowser } from '../../../common/utils/is-browser';

// TODO: Extract and use factory pattern for different trigger types.
const ROVO_BUTTON_TRIGGER_TYPE = 'ROVO_BUTTON_NUDGE_PAGE_LOAD';

const CONVO_AI_URL = '/gateway/api/assist/api/ai/v2/ai-feature/proactive';

type FetchNudgeRecommendationsProps = {
	pageUrl: string;
	product: string;
	triggerId: string;
};

export const fetchNudgeRecommendations = async ({
	triggerId,
	pageUrl,
	product,
}: FetchNudgeRecommendationsProps): Promise<undefined | RovoButtonNudgeRecommendationResponse> => {
	if (isBrowser() && window.AIX_DEBUG_NUDGE_TRIGGERS?.hasTriggers) {
		return {
			triggers: [
				{
					recommendations: [
						{
							recommendation_details: window.AIX_DEBUG_NUDGE_TRIGGERS?.useNextTrigger(),
						},
					],
				},
			],
		} as RovoButtonNudgeRecommendationResponse;
	}

	const request: AiFeatureRequestEnvelopeRovoButtonNudgeRecommendationRequest = {
		ai_feature_input: {
			triggers: [
				{
					trigger_id: triggerId,
					trigger_details: {
						page_url: pageUrl,
					},
					trigger_type: ROVO_BUTTON_TRIGGER_TYPE,
				},
			],
		},
	};

	const response = await fetch(CONVO_AI_URL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
			'X-Product': product,
			'X-Experience-Id': fg('rovo_button_experience_id_enabled')
				? 'proactive-ai-rovo-button'
				: 'ai-mate',
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(
			`Error fetching agent recommendations and convo starters, status code: ${response.status}`,
		);
	}

	// Allow error to raise if response is not valid JSON
	// Allow undefined to be returned if ai_feature_output is not present
	return (await response.json())?.ai_feature_output;
};
